const polls = [
       {
        id: '65v34j',
        title: 'Which framework is best for front end development?',
        description: 'The State of JavaScript 2019 concludes that React, Angular, and Vue are most popular among developers, which makes them the top three frontend frameworks of 2020.',
        options: [
            { id: '934544', value: 'React.js', vote: 0 },
            { id: '683254', value: 'Veu.js', vote: 0 },
            { id: '270692', value: 'Angular.js', vote: 0 },
            { id: '978793', value: 'Backbone.js', vote: 0 },
            { id: '524578', value: 'jQuery', vote: 0 },
        ],
        created: new Date(),
        totalVote: 0,
        opinions: []
    },
    {
        id: '32d231',
        title: 'What is the best way to create an android app?',
        description: 'Yes it would be very difficult to make android app at very beginning . You should know basic of Java & all design pattern. Knowledge is key to making Android app. Few things required to make App.',
        options: [
            { id: '432344', value: 'React Native', vote: 0 },
            { id: '434344', value: 'Ionic', vote: 0 },
            { id: '432792', value: 'Kotlin', vote: 0 },
            { id: '438793', value: 'Fluter', vote: 0 },
            { id: '436578', value: 'Java', vote: 0 },
        ],
        created: new Date(),
        totalVote: 0,
        opinions: []
    },
    {
        id: '324d5b',
        title: 'What is your favorite programming language?',
        description: 'Coding is not hard to learn. If you take the time and have a little patience, you can really learn just about anything–coding is no exception. Learning to code takes time and persistence, but if you have that, then coding is not hard to learn',
        options: [
            { id: '892344', value: 'JavaScript', vote: 0 },
            { id: '684344', value: 'Python', vote: 0 },
            { id: '272792', value: 'Go lang', vote: 0 },
            { id: '948793', value: 'C Programming', vote: 0 },
            { id: '516578', value: 'Dart', vote: 0 },
        ],
        created: new Date(),
        totalVote: 0,
        opinions: []
    }
];

export default polls;